export default class BajaLoc {
  #repository
  constructor(repository) {
    this.#repository = repository
  }

  async execute(idLoc, payload) {
    try {
      const result = await this.#repository.bajaLoc(idLoc, payload)
      return result
    } catch (error) {
      console.log(error)
      throw error
    }
  }
}
